(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rare-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  const initializeRareNewsletterPopup = (root) => {
    if (!root || root.dataset.initialized === 'true') return;

    const dialog = root.querySelector('.rare-newsletter-popup__dialog');
    const status = root.querySelector('[data-popup-status]')?.dataset.popupStatus || 'idle';
    const delay = Number(root.dataset.delayMs) || 0;
    const designMode = root.dataset.designMode === 'true';
    const storageKey = 'rare-newsletter-popup-shown-v3';
    let timer;

    if (!dialog) return;

    root.dataset.initialized = 'true';

    const hasShown = () => {
      try {
        return localStorage.getItem(storageKey) === 'true';
      } catch {
        return false;
      }
    };

    const rememberShown = () => {
      if (designMode) return;

      try {
        localStorage.setItem(storageKey, 'true');
      } catch {
        return;
      }
    };

    const openPopup = (remember = false) => {
      if (!dialog.open) {
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        if (remember) rememberShown();
      }
    };

    const closePopup = () => {
      rememberShown();
      if (dialog.open) dialog.close();
    };

    const schedulePopup = () => {
      if (designMode || status === 'error' || status === 'success') {
        openPopup();
        if (status === 'success') rememberShown();
        return;
      }

      if (hasShown()) return;
      timer = window.setTimeout(() => openPopup(true), delay);
    };

    root.querySelectorAll('[data-rare-newsletter-close]').forEach((button) => {
      button.addEventListener('click', closePopup);
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closePopup();
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closePopup();
    });

    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = '';
    });

    root.addEventListener('shopify:block:select', openPopup);
    schedulePopup();

    root.addEventListener('rare-newsletter-popup:destroy', () => {
      window.clearTimeout(timer);
      if (dialog.open) dialog.close();
    }, { once: true });
  };

  document.querySelectorAll('[data-rare-newsletter-popup]').forEach(initializeRareNewsletterPopup);

  document.addEventListener('shopify:section:load', (event) => {
    initializeRareNewsletterPopup(event.target.querySelector('[data-rare-newsletter-popup]'));
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelector('[data-rare-newsletter-popup]')?.dispatchEvent(new CustomEvent('rare-newsletter-popup:destroy'));
  });

  } catch(e) { console.error(e); }
})();
})();
